import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatIconModule } from "@angular/material/icon";
import { AiHubContextMenuModule } from "@aihub/ui/context-menu";

import { AiHubCommonModule } from "@aihub/ui/common";
import { AiHubTagsModule } from "@aihub/ui/tags";

import { TranslateModule, TranslateService } from "@ngx-translate/core";
import i18n_en from "./i18n/en.json";

import { DeloitteAiBuyerOfferCardComponent } from "./ui/offer-card.buyer";

import {
    DeloitteAiProductCardComponent,
    DeloitteAiProductCardIconDirective,
} from "./ui/product-card";

import { DeloitteAiCommonModule } from "@shared/common/common.module";
import { DeloitteAiSkuCardComponent } from "./ui/sku-card";
import { DeloitteAiPlanCardComponent } from "./ui/plan-card";
import { DeloitteAiCardActionDirective } from "./ui/card-action";

@NgModule({
    declarations: [
        DeloitteAiBuyerOfferCardComponent,
        DeloitteAiPlanCardComponent,
        DeloitteAiSkuCardComponent,
        DeloitteAiProductCardComponent,
        DeloitteAiProductCardIconDirective,
        DeloitteAiCardActionDirective,
    ],
    imports: [
        CommonModule,
        AiHubCommonModule,
        AiHubContextMenuModule,
        AiHubTagsModule,
        DeloitteAiCommonModule,
        MatIconModule,
        TranslateModule.forChild(),
    ],
    exports: [
        DeloitteAiBuyerOfferCardComponent,
        DeloitteAiPlanCardComponent,
        DeloitteAiSkuCardComponent,
        DeloitteAiProductCardComponent,
        DeloitteAiProductCardIconDirective,
        DeloitteAiCardActionDirective,
    ],
    providers: [],
})
export class DeloitteAiCardsModule {
    public constructor(translateService: TranslateService) {
        translateService.setTranslation("en", i18n_en, true);
    }
}
